import { useQuery } from '@tanstack/react-query';
import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

export const getIntegrationStatus = (
  dispatch: Dispatch,
  secretId: string,
  id: string,
) =>
  useQuery({
    queryKey: ['integrations', 'status', id],
    queryFn: async (): Promise<{ status: boolean } | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/express/${secretId}/integrations/status/${id}`,
        dispatch,
      });
      if (response) return response.data;
      return undefined;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
    retry: 1,
  });
